import {Component, Input} from '@angular/core';
import {ListingAttributeValueView} from '../attribute-schema.service';
import {isBuyerVisibleAttribute} from '../attribute-form-layout.utils';

@Component({
  standalone: false,
  selector: 'app-listing-attributes-panel',
  templateUrl: './listing-attributes-panel.component.html',
  styleUrls: ['./listing-attributes-panel.component.scss'],
})
export class ListingAttributesPanelComponent {
  @Input() attributes: ListingAttributeValueView[] = [];
  @Input() title = 'Listing details';
  /** When true (default), hide attributes marked buyerVisible=false. */
  @Input() buyerFacing = true;

  get visibleAttributes(): ListingAttributeValueView[] {
    return (this.attributes || []).filter(attr => {
      if (!this.hasDisplayValue(attr)) {
        return false;
      }
      if (this.buyerFacing && !isBuyerVisibleAttribute(attr)) {
        return false;
      }
      return true;
    });
  }

  formatValue(attr: ListingAttributeValueView): string {
    if (attr.displayValue != null && `${attr.displayValue}`.trim() !== '') {
      return String(attr.displayValue);
    }
    const value = attr.value;
    if (Array.isArray(value)) {
      return value.map(entry => String(entry)).join(', ');
    }
    return value != null ? String(value) : '';
  }

  hasDisplayValue(attr: ListingAttributeValueView): boolean {
    return this.formatValue(attr).trim().length > 0;
  }
}
